import { FieldType, OperatorNames } from '@msdk/definitions'

import { OPERATORS, OptionEntry } from './operators'

export function getDefaultOperatorName(type: FieldType): OperatorNames | undefined {
  let res: OptionEntry | undefined = undefined
  switch (type) {
    case 'String':
      res = OPERATORS['StartsWith']
      break
  }
  return res?.value as OperatorNames
}

export function getOperators(type: FieldType): OptionEntry[] {
  const res: OptionEntry[] = []
  res.push(OPERATORS['IsNullOrEmpty'])
  res.push(OPERATORS['IsNotNullOrEmpty'])
  switch (type) {
    case 'DateTime':
    case 'DateTimeUnknown':
      res.push(OPERATORS['Is'])
      res.push(OPERATORS['IsNot'])
      res.push(OPERATORS['After'])
      res.push(OPERATORS['OnOrAfter'])
      res.push(OPERATORS['Before'])
      res.push(OPERATORS['OnOrBefore'])
      break
    case 'Lookup':
      res.push(OPERATORS['Equals'])
      res.push(OPERATORS['NotEquals'])
      res.push(OPERATORS['IsBuAncestor'])
      res.push(OPERATORS['IsBuDescendant'])
      break
    case 'Numeric':
      res.push(OPERATORS['Equals'])
      res.push(OPERATORS['Greater'])
      res.push(OPERATORS['GreaterOrEqual'])
      res.push(OPERATORS['LowerOrEqual'])
      res.push(OPERATORS['Lower'])
      res.push(OPERATORS['NotEquals'])
      break
    case 'OptionSet':
      res.push(OPERATORS['Equals'])
      res.push(OPERATORS['In'])
      res.push(OPERATORS['NotEquals'])
      break
    case 'String':
      res.push(OPERATORS['Equals'])
      res.push(OPERATORS['In'])
      res.push(OPERATORS['NotEquals'])
      res.push(OPERATORS['Contains'])
      res.push(OPERATORS['StartsWith'])
      break
    case 'Attachment':
    case 'Image':
    case 'List':
    case 'Bag':
      break
    default:
      throw new Error(`Unsupported field type: ${type}`)
  }
  return res
}
